var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-category-selector" },
    [
      _c(
        "yxt-popover",
        {
          ref: "dropdown",
          attrs: {
            "custom-elm": "",
            trigger: "click",
            placement: "bottom-start",
            "popper-class": "yxtbiz-category-selector-pop",
            "visible-arrow": false,
            width: _vm.width,
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm.multiple
            ? _c("yxt-select", {
                attrs: {
                  slot: "reference",
                  disabled: _vm.disabled,
                  multiple: _vm.multiple,
                  placeholder: _vm.placeholder,
                  clearable: _vm.clearable,
                  "collapse-tags": "",
                  "collapse-tags-auto": "",
                  "hidden-option": "",
                  "value-key": "nodeId",
                  "prop-label": "nodeName",
                  multipleLimit: _vm.limit,
                  "hide-on-click": false,
                },
                on: { "remove-tag": _vm.removeTag, clear: _vm.clearChecked },
                slot: "reference",
                model: {
                  value: _vm.checkedList,
                  callback: function ($$v) {
                    _vm.checkedList = $$v
                  },
                  expression: "checkedList",
                },
              })
            : _c("yxt-select", {
                attrs: {
                  slot: "reference",
                  clearable: _vm.clearable,
                  placeholder: _vm.placeholder,
                  multiple: _vm.multiple,
                  "collapse-tags": "",
                  "collapse-tags-auto": "",
                  "hidden-option": "",
                  "value-key": "nodeId",
                  "prop-label": "nodeName",
                  "hide-on-click": false,
                },
                on: { clear: _vm.handleSelected },
                slot: "reference",
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
          _c(
            "div",
            { staticStyle: { padding: "24px" } },
            [
              _vm.multiple
                ? _c("yxtbiz-category-tree", {
                    ref: "tree",
                    staticStyle: { width: "100%", height: "400px" },
                    attrs: {
                      apiName: _vm.apiName,
                      firstModifiable: false,
                      modifiable: { add: false, delete: false, modify: false },
                      code: _vm.code,
                      type: _vm.type,
                      navCode: _vm.navCode,
                      dataPermissionCode: _vm.dataPermissionCode,
                      sortable: false,
                      multiple: _vm.multiple,
                      checkedIds: _vm.checkedList.map(function (i) {
                        return i.nodeId
                      }),
                      placeholder: _vm.searchPlaceholder,
                      limit: _vm.limit,
                    },
                    on: {
                      addChecked: _vm.addChecked,
                      removeChecked: _vm.removeChecked,
                    },
                  })
                : _c("yxtbiz-category-tree", {
                    ref: "tree",
                    staticStyle: { width: "100%", height: "400px" },
                    attrs: {
                      disabledLast: _vm.disabledLast,
                      apiName: _vm.apiName,
                      placeholder: _vm.searchPlaceholder,
                      type: _vm.type,
                      firstModifiable: false,
                      modifiable: { add: false, delete: false, modify: false },
                      code: _vm.code,
                      navCode: _vm.navCode,
                      dataPermissionCode: _vm.dataPermissionCode,
                      sortable: false,
                      multiple: _vm.multiple,
                      selectedId: _vm.selected ? _vm.selected.nodeId : "",
                    },
                    on: { select: _vm.handleSelected },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }